"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.createWorkflowsEpic = exports.fetchWorkflowsEpic = exports.deleteWorkflowsEpic = void 0;

var _reduxObservable = require("redux-observable");

var _actions = require("./actions");

var _selectors = require("settings-ui-sdk/QuoteAutomation/selectors");

var _requestEntity = _interopRequireDefault(require("settings-ui-sdk/requestEntity"));

var _RequestEpicDescriptor = _interopRequireDefault(require("settings-ui-sdk/RequestEpicDescriptor"));

var _RequestStatusTypes = _interopRequireDefault(require("settings-ui-sdk/constants/RequestStatusTypes"));

var _API = _interopRequireDefault(require("./API"));

var deleteWorkflowsEpic = (0, _requestEntity.default)(new _RequestEpicDescriptor.default({
  apiFunction: _API.default.deleteWorkflow,
  initiatingActionType: _actions.QuoteAutomationActionTypes.DELETE_WORKFLOWS,
  requestActions: _actions.DeleteWorkflows,
  requestStatusTypeFilters: [_RequestStatusTypes.default.UNINITIALIZED, _RequestStatusTypes.default.FAILED, _RequestStatusTypes.default.SUCCEEDED],
  requestStatusSelector: _selectors.getWorkflowsDeleteStatus
}));
exports.deleteWorkflowsEpic = deleteWorkflowsEpic;
var fetchWorkflowsEpic = (0, _requestEntity.default)(new _RequestEpicDescriptor.default({
  apiFunction: _API.default.fetchWorkflows,
  initiatingActionType: _actions.QuoteAutomationActionTypes.FETCH_WORKFLOWS,
  requestActions: _actions.FetchWorkflows,
  requestStatusTypeFilters: [_RequestStatusTypes.default.UNINITIALIZED, _RequestStatusTypes.default.FAILED, _RequestStatusTypes.default.SUCCEEDED],
  requestStatusSelector: _selectors.getWorkflowsFetchStatus
}));
exports.fetchWorkflowsEpic = fetchWorkflowsEpic;
var createWorkflowsEpic = (0, _requestEntity.default)(new _RequestEpicDescriptor.default({
  apiFunction: _API.default.createWorkflows,
  initiatingActionType: _actions.QuoteAutomationActionTypes.CREATE_WORKFLOWS,
  requestActions: _actions.CreateWorkflows,
  requestStatusTypeFilters: [_RequestStatusTypes.default.UNINITIALIZED, _RequestStatusTypes.default.PENDING, _RequestStatusTypes.default.FAILED, _RequestStatusTypes.default.SUCCEEDED],
  requestStatusSelector: _selectors.getWorkflowsCreateStatus
}));
exports.createWorkflowsEpic = createWorkflowsEpic;

var _default = (0, _reduxObservable.combineEpics)(deleteWorkflowsEpic, fetchWorkflowsEpic, createWorkflowsEpic);

exports.default = _default;